module.exports = __webpack_public_path__ + "assets/images/mbk-logo.d6406f84.jpg";